import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { api } from "../../App/API/api";


export const fetchShowAbout = createAsyncThunk(
    'about/showAbout',
    async (id, { rejectWithValue }) => {
        try {

            const response = await api.get(`/about/${id}`)
            console.log(response)
            return {about:response.data.data,type:response.data.type};
        } catch (error) {
            console.error("API Error:", error);
            return rejectWithValue(error.response?.data || error.message);
        }
    }
);


const showAboutSlice = createSlice({    
    name: "showAbout",
    initialState: {
        loading: false,
        error: null,
        about: null,
        types:[],
    },
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(fetchShowAbout.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(fetchShowAbout.fulfilled, (state, action) => {
                state.loading = false;
                state.error = null;
                state.about = action.payload.about;
                state.types = action.payload.type;
            })
            .addCase(fetchShowAbout.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            });
    },
});

export default showAboutSlice.reducer;